import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_CLIENTS_INDUSTRIES_REQUEST } from "../actions/fetchClientIndustriesCompetitorsActions";
import {
  fetchClientsIndustriesSuccess,
  fetchClientsIndustriesFailure,
} from "../actions/fetchClientIndustriesCompetitorsActions";
import { fetchClientsWithIndustries } from "../../../services/accIqService";

function* fetchClientsIndustriesSaga() {
  try {
    const response = yield call(fetchClientsWithIndustries);
    yield put(fetchClientsIndustriesSuccess(response));
  } catch (error) {
    yield put(
      fetchClientsIndustriesFailure(
        error?.response?.data?.message || "Something went wrong"
      )
    );
  }
}

export default function* watchClientIndustriesCompetitorsSaga() {
  yield takeLatest(
    FETCH_CLIENTS_INDUSTRIES_REQUEST,
    fetchClientsIndustriesSaga
  );
}
